import { TableCell, TableRow } from '@material-ui/core';
import React from 'react';

const HolderModalHeighestPuts = ({ callData, isMobile, styles }) => {
  return (
    <TableRow>
      <TableCell
        colSpan={8}
        style={
          isMobile
            ? {
                ...styles.filerRowMobile,
                backgroundColor: callData.color,
                paddingTop: callData.paddingTop,
                whiteSpace: 'nowrap',
              }
            : {
                ...styles.filerRow,
                backgroundColor: callData.color,
                paddingTop: callData.paddingTop,
              }
        }
        align="left"
        className="sticky"
      >
        {isMobile ? callData.name.substr(0, 12) : callData.name}
      </TableCell>

      <TableCell
        colSpan={1}
        style={
          isMobile
            ? {
                ...styles.filerRowMobile,
                backgroundColor: callData.color,
                textAlign: 'end',
              }
            : {
                ...styles.filerRow,
                backgroundColor: callData.color,
                textAlign: 'end',
              }
        }
        align="left"
        className="sticky"
      >
        {callData.cel1}
      </TableCell>
      <TableCell
        colSpan={1}
        style={
          isMobile
            ? {
                ...styles.filerRowMobile,
                backgroundColor: callData.color,
                textAlign: 'end',
              }
            : {
                ...styles.filerRow,
                backgroundColor: callData.color,
                textAlign: 'end',
              }
        }
        align="left"
        className="sticky"
      >
        {callData.cel2}
      </TableCell>

      <TableCell
        colSpan={1}
        style={
          isMobile
            ? {
                ...styles.filerRowMobile,
                backgroundColor: callData.color,
                width: '60px',
                textAlign: 'end',
              }
            : {
                ...styles.filerRow,
                backgroundColor: callData.color,
                textAlign: 'end',
              }
        }
        align="left"
        className="sticky"
      >
        {callData.cel3}
      </TableCell>
    </TableRow>
  );
};
export default HolderModalHeighestPuts;



// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/components/holderModalHeighestPuts.jsx